import { authorizeManageMissionByMissionId } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { areParticipantsInOverlappingShifts } from './areParticipantsInOverlappingShifts';
export function canApproveVolunteers(userContext, data, shift) {
    if (!authorizeManageMissionByMissionId(userContext, userContext.userState, shift.columns.missionId)) {
        throw new AuthError('Unauthorized, user cannot approve volunteers');
    }
    const currentTime = Date.now();
    if (shift.columns.stopTime < currentTime) {
        throw new AuthError('Cannot approve volunteers for past shift');
    }
    if (data.shiftParticipations.some((participation) => { var _a; return (_a = shift.data.usersApprovedForShift) === null || _a === void 0 ? void 0 : _a.includes(participation.shiftParticipantId); })) {
        throw new AuthError('Volunteer already approved for shift');
    }
    const accountIds = data.shiftParticipations.map(({ shiftParticipantId }) => shiftParticipantId);
    if (!areParticipantsInOverlappingShifts(userContext, shift, accountIds)) {
        throw new AuthError('At least one volunteer has already been approved for a shift with a time that overlaps this one and cannot be approved.');
    }
}
